import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { getRolesByUrl } from '../../core/configs/navigation.config';
import { SessionBootstrapService } from '../../core/configs/session.resolver';
import { PermissionService } from '../../core/services/permission.service';

const normalizeRoles = (roles: string | string[]): string[] =>
  Array.isArray(roles) ? roles : [roles];

// Exportada para o spec: a decisão do guard sem o wrapper do keycloak-angular.
export const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const { authenticated } = authData;
  // inject() só vale antes do primeiro await (contexto de injeção).
  const router = inject(Router);
  const session = inject(SessionBootstrapService);
  const permissions = inject(PermissionService);

  if (!authenticated) {
    return router.parseUrl('/');
  }

  // Permissão EFETIVA (teto do Keycloak cruzado com o perfil de acesso do grupo da empresa
  // ativa), não a role crua do token. Carrega em TODA rota do shell, inclusive as sem role (a
  // /home, onde o usuário cai): é ela que desenha o menu, a paleta e os cartões. A empresa ativa
  // precisa existir antes, porque o perfil é por grupo.
  await session.ensure();
  await permissions.ensureLoaded();

  // First check route data, then fallback to central navigation config
  let requiredRoles = route.data['roles'];

  if (!requiredRoles) {
    requiredRoles = getRolesByUrl(state.url);
  }

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  if (permissions.hasAny(normalizeRoles(requiredRoles))) {
    return true;
  }

  return router.parseUrl('/forbidden');
};

export const canActivateAuthRole =
  createAuthGuard<CanActivateFn>(isAccessAllowed);
